export default function loaders(state = {}, action) {
  if (action.type === 'SHOW_LOADER') {
    const { name, config = {} } = action;
    const nextState = { ...state };
    if (!nextState[name]) {
      nextState[name] = {
        name,
        state: config.state
      };
      return nextState;
    }
  } else if (action.type === 'HIDE_LOADER') {
    const { name } = action;
    const nextState = { ...state };
    if (nextState[name]) {
      delete nextState[name];
      return nextState;
    }
  }
  return state;
}
